import React from "react";
import styles from "./VoucherSellerComments.module.scss";
import {IProduct} from 'data/interfaces/products';
import SellerComments from 'gui/pages/mainRouter/pages/ad/components/commons/sellerComments';
import {voucherText} from 'gui/components/listPage/components/ad/components/voucherImageSquare';
import PercentTicket from 'gui/components/icons/PercentTicket';
import {createSelector} from "redux-starter-kit";

export interface IVoucherSellerCommentsProps {
  product: IProduct;
}



const descriptionSelector = createSelector(['product.voucherDetails.description']);

const VoucherSellerComments = (props: IVoucherSellerCommentsProps) => <SellerComments
  title={voucherText(props.product)}
  icon={PercentTicket}
  iconContainerClassName={styles.VoucherSellerComments}
  description={descriptionSelector(props)}
/>;

VoucherSellerComments.defaultProps = {
  product: {voucherDetails: {}},
};

export default VoucherSellerComments;
